export const BRAND = "Destino Resorts";
export const DOMAIN = "destinoresorts.com.br";

export const WA_PRIMARY = "5547991624421";
export const WA_PRIMARY_DISPLAY = "(47) 99162-4421";
export const WA_PRIMARY_LABEL = "Cotações & vendas — linha principal";
export const WA_SECONDARY = "5547989251767";
export const WA_SECONDARY_DISPLAY = "(47) 98925-1767";
export const WA_SECONDARY_LABEL = "Cotações & vendas — linha alternativa";

export const INSTAGRAM_FAZZENDA = "https://www.instagram.com/fazzendaparkresort";

export const waLink = (number, message) =>
    `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

export const DIRECT_MSG =
    "Olá! Estou no portal Destino Resorts e gostaria de receber uma cotação com valores diferenciados.";

export const TRANSPARENCY =
    "A Destino Resorts é uma agência de viagens independente, especializada em experiências e hospedagens. Não representa os sites oficiais dos empreendimentos apresentados. Todas as marcas, logotipos e referências pertencem a seus respectivos proprietários.";

export const NAV_LINKS = [
    { id: "explore-resorts", label: "Explore os Resorts", testid: "nav-link-explore", type: "anchor" },
    { id: "como-funciona", label: "Como Funciona", testid: "nav-link-how-it-works", type: "anchor" },
    { id: "depoimentos", label: "Depoimentos", testid: "nav-link-testimonials", type: "anchor" },
];

export const HOME_MARQUEE = [
    "Pensão Completa",
    "All Inclusive",
    "Águas Termais",
    "Pé na Areia",
    "Natureza Preservada",
    "Recreação Infantil",
    "Gastronomia Premiada",
    "Ecoturismo",
];

export const HOW_IT_WORKS = [
    {
        icon: "Compass",
        title: "1. Explore os resorts",
        text: "Conheça nossa curadoria de resorts de família, natureza e descanso — com fotos, detalhes e diferenciais de cada destino.",
    },
    {
        icon: "FileText",
        title: "2. Solicite sua cotação",
        text: "Preencha datas, hóspedes e preferências em menos de 1 minuto. Sem cadastro, sem compromisso e sem custo.",
    },
    {
        icon: "MessageCircle",
        title: "3. Receba no WhatsApp",
        text: "Sua solicitação chega pronta para nossa equipe, que responde com a proposta personalizada e condições diferenciadas para o seu período.",
    },
];

export const PORTAL_FAQS = [
    {
        id: "pfaq-1",
        q: "O Destino Resorts é o site oficial dos resorts?",
        a: "Não. Somos um portal independente de curadoria e captação de cotações. Você solicita por aqui e nossa equipe retorna pelo WhatsApp com valores, condições e disponibilidade do período escolhido.",
    },
    {
        id: "pfaq-2",
        q: "A cotação tem algum custo?",
        a: "Nenhum. A solicitação de cotação é 100% gratuita e sem compromisso. Você só avança com a reserva se a proposta fizer sentido para você.",
    },
    {
        id: "pfaq-2b",
        q: "Por que cotar pelo portal e não direto no site do resort?",
        a: "Quem cota pelo Destino Resorts tem condições diferenciadas, negociadas com cada resort parceiro — e ainda conta com nossa curadoria para comparar destinos e encontrar o melhor encaixe para o seu perfil de viagem.",
    },
    {
        id: "pfaq-3",
        q: "Como recebo os valores e a disponibilidade?",
        a: "Ao enviar o formulário, o WhatsApp abre com sua mensagem pronta para o nosso número principal (47) 99162-4421. A partir daí, a equipe consulta o resort e responde com a proposta personalizada.",
    },
    {
        id: "pfaq-4",
        q: "Posso cotar mais de um resort ao mesmo tempo?",
        a: "Pode. Escolha a opção 'Outro / Quero recomendação personalizada' ou envie uma nova cotação para cada resort — comparar destinos é uma das vantagens do portal.",
    },
    {
        id: "pfaq-5",
        q: "Novos resorts serão adicionados ao catálogo?",
        a: "Sim. O catálogo está em constante expansão, sempre com foco em resorts de experiência para famílias, casais e grupos.",
    },
];

export const LEAD_STATUSES = [
    { value: "novo", label: "Novo lead" },
    { value: "qualificado_ia", label: "Qualificado pelo Agente IA" },
    { value: "cotacao_solicitada", label: "Cotação solicitada" },
    { value: "aguardando_resort", label: "Aguardando resort" },
    { value: "cotacao_recebida", label: "Cotação recebida do resort" },
    { value: "cotacao_enviada", label: "Cotação enviada ao cliente" },
    { value: "aguardando_cliente", label: "Aguardando cliente" },
    { value: "cliente_aprovou", label: "Cliente aprovou" },
    { value: "reserva_solicitada", label: "Reserva solicitada ao resort" },
    { value: "reserva_confirmada", label: "Reserva confirmada" },
    { value: "hospedagem_concluida", label: "Hospedagem concluída" },
    { value: "cancelado", label: "Cancelado" },
    { value: "perdido", label: "Perdido" },
];

export const buildQuoteMessage = ({ resortLabel, firstName, lastName, phone, email, checkin, checkout, nights, adults, children, ages, notes }) => {
    const fmt = (iso) => iso.split("-").reverse().join("/");
    const kidsAges = children === 0 ? "—" : ages.slice(0, children).map((a) => `${a} anos`).join(", ");
    return [
        "*NOVA SOLICITAÇÃO DE COTAÇÃO — DESTINO RESORTS*",
        "----------------------------------------",
        `*Resort:* ${resortLabel}`,
        `*Nome:* ${[firstName, lastName].filter(Boolean).join(" ")}`,
        `*WhatsApp:* ${phone}`,
        `*E-mail:* ${email?.trim() ? email.trim() : "—"}`,
        `*Período:* ${fmt(checkin)} até ${fmt(checkout)} (${nights} ${nights === 1 ? "diária" : "diárias"})`,
        `*Hóspedes:* ${adults} ${adults === 1 ? "adulto" : "adultos"} e ${children} ${children === 1 ? "criança" : "crianças"}`,
        `*Idade das crianças:* ${kidsAges}`,
        `*Observações:* ${notes?.trim() ? notes.trim() : "—"}`,
        "----------------------------------------",
        "_Cotação com condições diferenciadas · destinoresorts.com.br_",
    ].join("\n");
};
